import React, {useRef, useState} from "react";
import {useTranslation} from "react-i18next";
import Moment from "react-moment";
import {useDispatch, useSelector} from "react-redux";

import {getCurrentUser, logout} from "../../../slices/UserSlice";
import IconButton from "../../../utilities/Buttons/IconButton";
import {ICON_NAMES} from "../../../utilities/generalConstants.js/generalConstants";
import {swalCustom} from "../../../utilities/hooks/swalCustom";
import ToolTip, {TOOLTIP_PLACEMENT} from "../../../utilities/ToolTip";
import {UI_PERMISSION_TYPE} from "../../adminForms/Ba3aSettings/tabs/PositionsSettings/useRoutePermissions";

import CurrData from "./CurrData";

const NavbarInfo = () => {
  const dispatch = useDispatch();
  const {i18n} = useTranslation();

  const user = useSelector(getCurrentUser);
  const userName =
    i18n.language === "en"
      ? `${user?.engLastName || ""} ${user?.engName || ""}`
      : `${user?.lastName || ""} ${user?.firstName || ""}`;

  const [rates, setRates] = useState([]);
  const ratesUpdateTime = useRef();

  const officeShortName = user?.orgStructure?.shortName || "";
  return (
    <div className="navbar__datetime">
      <ToolTip
        leaveDelay={1500}
        title={<CurrData rates={rates} setRates={setRates} ratesUpdateTime={ratesUpdateTime} />}
        bottom
        placement={TOOLTIP_PLACEMENT.BOTTOM_START}
        className="navbar__datetime_wrapper pointer"
      >
        <>
          <h1>
            <Moment format="DD.MM.YYYY" />
          </h1>
          <h1>
            <Moment format="HH:mm" interval={1000 * 60} />
          </h1>
        </>
      </ToolTip>
      {user && Object.prototype.hasOwnProperty.call(user, "login") && (
        <div className="user_label__container gap0_5">
          <label htmlFor="" className="label user_label" style={{overflow: "hidden"}}>
            {officeShortName ? (
              <>
                <span>{officeShortName}</span> | {userName}
              </>
            ) : (
              userName
            )}
          </label>
          {/* <img
            src={logoutPng}
            alt=""
            title={t("LogOut")}
            onClick={() => {
              swalCustom.confirm({
                confirmFunc: () => {
                  dispatch(logout());
                },
                text: "Are you sure you want to log out?",
              });
            }}
            draggable="false"
          /> */}
          <IconButton
            ariaLabel="LogOut"
            widthIcon={14}
            heightIcon={14}
            classNameBtn="logoutBtn"
            nameIcon={ICON_NAMES.LOGOUT}
            onClick={() => {
              swalCustom.confirm({
                confirmFunc: () => {
                  dispatch(logout());
                },
                text: "Are you sure you want to log out?",
              });
            }}
            uiPermissionType={UI_PERMISSION_TYPE.READABLE}
          />
        </div>
      )}
    </div>
  );
};

export default NavbarInfo;
